import { defineComponent as _defineComponent } from 'vue'
import Error from '@/components/Error.vue';
import Loader from '@/components/Loader.vue';
import ReLogin from '@/components/ReLogin.vue';
import DDos from '@/components/DDos.vue';
import '@ifr/form-questionnaire/dist/form-questionnaire.css';
import Success from '@/components/Success/index.vue';
import Chat from '@/widgets/chat/ui/Chat.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,Error, Loader, ReLogin, DDos, Success, Chat }
}

})